import type { Map } from 'mapbox-gl';

/** Layers that become large colored slabs at navigation pitch (60°). */
const HIDE_LAYER_ID = /polygon-fill|road-polygon-case|turning-feature/;

/** Dark nav line colors that disappear on the black basemap at close zoom. */
const DARK_ROAD_LINE_COLORS = new Set([
  'hsl(220, 10%, 24%)',
  'hsl(220, 10%, 32%)',
  '#3a4048',
]);

const NAV_ROAD_LINE_COLOR = 'hsl(220, 20%, 52%)';

function hidePolygonRoadFills(map: Map): void {
  for (const layer of map.getStyle()?.layers ?? []) {
    if (!HIDE_LAYER_ID.test(layer.id) || !map.getLayer(layer.id)) continue;
    map.setLayoutProperty(layer.id, 'visibility', 'none');
  }
}

function brightenDarkRoadLines(map: Map, layerId: string): void {
  const color = map.getPaintProperty(layerId, 'line-color');
  if (typeof color !== 'string' || !DARK_ROAD_LINE_COLORS.has(color)) return;
  map.setPaintProperty(layerId, 'line-color', NAV_ROAD_LINE_COLOR);
}

/**
 * Navigation-only style adjustments:
 * - Hide road polygon fills (yellow/orange slabs at pitch)
 * - Improve minor-road contrast on dark nav basemap
 */
export function applyNavigationMapTweaks(map: Map): void {
  if (!map.isStyleLoaded()) return;

  hidePolygonRoadFills(map);

  for (const layer of map.getStyle()?.layers ?? []) {
    if (!map.getLayer(layer.id)) continue;
    if (layer.type === 'line' && layer.id.startsWith('road-') && !layer.id.includes('case')) {
      brightenDarkRoadLines(map, layer.id);
    }
  }
}
